<!--
 * @Description: 教职工 详情
 * @Author: PF
 * @Date: 2023-03-08 10:33:25.239
 * @LastEditors: PF
 * @LastEditTime: 2023-03-13 15:35:06
-->
<template>
  <div>
    <el-dialog class="w1000 hp80" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>

      <el-tabs v-model="activeName">
        <el-tab-pane label="基本信息" :name="0" />
        <el-tab-pane v-for="item in tabData" :key="item.value" :name="item.value" :label="item.name" />
      </el-tabs>
      <div class="nei-rong">
        <jibenxinxi v-if="activeName ===  0" :row="row"/>
        <dangzhengzhiwu v-if="activeName ===  1" :row="row"/>
        <dangtuanxinxi v-if="activeName ===  2" :row="row"/>
        <shehuijianzhi v-if="activeName ===  3" :row="row"/>
        <xueshutuantijianzhi v-if="activeName ===  4" :row="row"/>
        <xuexijianli v-if="activeName ===  5" :row="row"/>
        <gongzuojianli v-if="activeName ===  6" :row="row"/>
        <xuelixuewei v-if="activeName ===  7" :row="row"/>
        <zhuanyenengliyuzigezhengshu v-if="activeName ===  8" :row="row"/>
        <yuyannengli v-if="activeName ===  9" :row="row"/>
        <zhuanyejishuzhiwu v-if="activeName ===  10" :row="row"/>
        <gangweizhengshu v-if="activeName ===  11" :row="row"/>
        <gongrenjishudengjijizhiwu v-if="activeName ===  12" :row="row"/>
        <guoneijinxiuxuexi v-if="activeName ===  13" :row="row"/>
        <chuguojingjinxiuxuexi v-if="activeName ===  14" :row="row"/>
        <jiangli v-if="activeName ===  15" :row="row"/>
        <chengchu v-if="activeName ===  16" :row="row"/>
        <zuzhikaocha v-if="activeName ===  17" :row="row"/>
        <waijijiaoshipinyong v-if="activeName ===  18" :row="row"/>
        <shuangshixingjiaoshipinyong v-if="activeName ===  19" :row="row"/>
        <jianzhijiaoshipinyong v-if="activeName ===  20" :row="row"/>
        <jiaoxuekeyanchengguo v-if="activeName ===  21" :row="row"/>
        <fabiaolunwen v-if="activeName ===  22" :row="row"/>
        <zhuanzhujiaocaijiaocan v-if="activeName ===  23" :row="row"/>
        <zhuanlichengguo v-if="activeName ===  24" :row="row"/>
      </div>
      <!-- <el-tab-pane label="基本信息"><jibenxinxi :row="row"/></el-tab-pane>
        <el-tab-pane label="党政职务"><dangzhengzhiwu :row="row"/></el-tab-pane>
        <el-tab-pane label="党团信息"><dangtuanxinxi :row="row"/></el-tab-pane>
        <el-tab-pane label="社会兼职"><shehuijianzhi :row="row"/></el-tab-pane>
        <el-tab-pane label="学术团体兼职"><xueshutuantijianzhi :row="row"/></el-tab-pane>
        <el-tab-pane label="学习简历"><xuexijianli :row="row"/></el-tab-pane>
        <el-tab-pane label="工作简历"><gongzuojianli :row="row"/></el-tab-pane>
        <el-tab-pane label="学历学位"><xuelixuewei :row="row"/></el-tab-pane>
        <el-tab-pane label="专业能力与资格证书"><zhuanyenengliyuzigezhengshu :row="row"/></el-tab-pane>
        <el-tab-pane label="语言能力"><yuyannengli :row="row"/></el-tab-pane>
        <el-tab-pane label="专业技术职务"><zhuanyejishuzhiwu :row="row"/></el-tab-pane>
        <el-tab-pane label="岗位证书"><gangweizhengshu :row="row"/></el-tab-pane>
        <el-tab-pane label="工人技术等级及职务"><gongrenjishudengjijizhiwu :row="row"/></el-tab-pane>
        <el-tab-pane label="国内进修学习"><guoneijinxiuxuexi :row="row"/></el-tab-pane>
        <el-tab-pane label="出国（境）进修学习"><chuguojingjinxiuxuexi :row="row"/></el-tab-pane>
        <el-tab-pane label="奖励"><jiangli :row="row"/></el-tab-pane>
        <el-tab-pane label="惩处"><chengchu :row="row"/></el-tab-pane>
        <el-tab-pane label="组织考察"><zuzhikaocha :row="row"/></el-tab-pane>
        <el-tab-pane label="外籍教师聘用"><waijijiaoshipinyong :row="row"/></el-tab-pane>
        <el-tab-pane label="“双师型”教师聘用"><shuangshixingjiaoshipinyong :row="row"/></el-tab-pane>
        <el-tab-pane label="兼职教师聘用"><jianzhijiaoshipinyong :row="row"/></el-tab-pane>
        <el-tab-pane label="教学科研成果"><jiaoxuekeyanchengguo :row="row"/></el-tab-pane>
        <el-tab-pane label="发表论文"><fabiaolunwen :row="row"/></el-tab-pane>
        <el-tab-pane label="专著、教材、教参"><zhuanzhujiaocaijiaocan :row="row"/></el-tab-pane>
        <el-tab-pane label="专利成果"><zhuanlichengguo :row="row"/></el-tab-pane> -->
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openDetail', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, defineProps, watch, ref } from 'vue'
import { loadSelect, closeWindow } from '@/api/common.js'
import jibenxinxi from './jibenxinxi.vue'
import dangzhengzhiwu from './dangzhengzhiwu.vue'
import dangtuanxinxi from './dangtuanxinxi.vue'
import shehuijianzhi from './shehuijianzhi.vue'
import xueshutuantijianzhi from './xueshutuantijianzhi.vue'
import xuexijianli from './xuexijianli.vue'
import gongzuojianli from './gongzuojianli.vue'
import xuelixuewei from './xuelixuewei.vue'
import zhuanyenengliyuzigezhengshu from './zhuanyenengliyuzigezhengshu.vue'
import yuyannengli from './yuyannengli.vue'
import zhuanyejishuzhiwu from './zhuanyejishuzhiwu.vue'
import gangweizhengshu from './gangweizhengshu.vue'
import gongrenjishudengjijizhiwu from './gongrenjishudengjijizhiwu.vue'
import guoneijinxiuxuexi from './guoneijinxiuxuexi.vue'
import chuguojingjinxiuxuexi from './chuguojingjinxiuxuexi.vue'
import jiangli from './jiangli.vue'
import chengchu from './chengchu.vue'
import zuzhikaocha from './zuzhikaocha.vue'
import waijijiaoshipinyong from './waijijiaoshipinyong.vue'
import shuangshixingjiaoshipinyong from './shuangshixingjiaoshipinyong.vue'
import jianzhijiaoshipinyong from './jianzhijiaoshipinyong.vue'
import jiaoxuekeyanchengguo from './jiaoxuekeyanchengguo.vue'
import fabiaolunwen from './fabiaolunwen.vue'
import zhuanzhujiaocaijiaocan from './zhuanzhujiaocaijiaocan.vue'
import zhuanlichengguo from './zhuanlichengguo.vue'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const row = ref()
const activeName = ref(0)
const tabData = ref([])
const emits = defineEmits(['update:openDetail'])
watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      row.value = props.row
      loadSelect({
        url: '/api/v2/pdp/jiaozhigong/xiangqing/' + row.value.id,
        data: tabData,
        order: 'value',
        sort: 'asc'
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
<style lang="less" scoped>
:deep(.el-tabs__content) {
  display: none;
}
.nei-rong {
  height: calc(100% - 55px);
  overflow: auto;
  padding: 10px;
  :deep(.el-descriptions) {
    margin-bottom: 20px;
  }
}
</style>
